import React from "react";

export const YellowStarLine = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='30'
            fill='none'
            data-my-extension-installed='true'
            viewBox='0 0 30 30'
        >
            <path
                stroke='#888E91'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.5'
                d='m17.163 4.388 2.2 4.4c.3.612 1.1 1.2 1.774 1.312l3.988.662c2.55.425 3.15 2.275 1.313 4.1l-3.1 3.1c-.526.526-.813 1.538-.65 2.263l.887 3.837c.7 3.038-.912 4.213-3.6 2.625l-3.738-2.212c-.674-.4-1.787-.4-2.474 0l-3.738 2.212c-2.675 1.588-4.3.4-3.6-2.625l.888-3.837c.162-.725-.125-1.738-.65-2.263l-3.1-3.1c-1.825-1.825-1.238-3.674 1.312-4.1l3.988-.662c.662-.112 1.462-.7 1.762-1.312l2.2-4.4c1.2-2.388 3.15-2.388 4.338 0'
            ></path>
        </svg>
    )
};


